/** @format */
import { useTranslation } from 'next-i18next';
import React from 'react';

import { SearchFacet } from '@toucan/common/services/search/constants';

import { Link, LinkSize } from '@toucan/client/shared/components/link';

type SectionTitleChildNodeProps = {
    filterId: SearchFacet;
    isOpen: boolean;
    selectedCount: number;
    onClearAll: (filterId: SearchFacet) => void;
};

export const SectionTitleChildNode = ({
    filterId,
    isOpen,
    onClearAll,
    selectedCount,
}: SectionTitleChildNodeProps) => {
    const { t } = useTranslation();

    if (selectedCount === 0) {
        return null;
    }

    if (!isOpen) {
        return (
            <span className="extra-node-count">
                {t('{{count}} selected', { count: selectedCount })}
            </span>
        );
    }

    return (
        <Link
            size={LinkSize.SMALL}
            className="extra-node-clear"
            onClick={() => onClearAll(filterId)}
        >
            {t('Clear all')}
        </Link>
    );
};
